import { render } from "./IconsList.vue?vue&type=template&id=5133de44&scoped=true"
import script from "./IconsList.vue?vue&type=script&lang=js"
export * from "./IconsList.vue?vue&type=script&lang=js"

import "./IconsList.vue?vue&type=style&index=0&id=5133de44&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5133de44"

export default script